import { FavoriteId } from 'api/clients/FavoriteClient'
import { FavoriteService } from 'api/services/FavoriteService'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useMutation, useQueryClient } from 'react-query'
import { useDispatch } from 'react-redux'

export const useDeleteFavorite = () => {
  const currentWorkspaceId = useCurrentWorkspaceId()
  const queryClient = useQueryClient()
  const dispatch = useDispatch()

  const deleteFavorite = useMutation(
    async ({ id, title }: { id: number; title: string }) =>
      await FavoriteService.deleteFavorite(id as FavoriteId, dispatch),
    {
      onSuccess: (_, favorite) => {
        queryClient.invalidateQueries(['workspace', currentWorkspaceId, 'files', 'favorites'])
        showToastMessage(
          <span>
            <b>{favorite.title}</b> removed from your favorites.
          </span>,
          'success',
        )
      },
    },
  )

  return deleteFavorite
}
